// i18n
import i18n from 'i18n'

export default {
  name: 'theine-level',

  props: {
    theine: {type: String, required: false}
  },

  data () {
    return {
      i18n
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/beverages/theine-level/theine-level.js